import gql from 'graphql-tag';

const FRAGMENT_PLACE = gql`
  fragment placeDetails on Place {
    id
    street
    zipCode
    city
    state
    countryId
    country {
      id
      name
    }
    name
    workspaceId
    coordinate
  }
`;

export default {
  FRAGMENT_PLACE,
};
